import React from 'react';
import bgInactive from '../../../assets/bgInactive.png';
import bgActive from '../../../assets/bgActive.png';
import Close from '../../Reutilizaveis/CloseButton';
import { ReactComponent as TermosDeUso } from '../../../assets/novosicones/Termos/TermosDeUso.svg';

import './styles.scss';
import useWindowDimension from '../../../hooks/WindowDimension';

const Base = ({
  children,
  etapa,
  nomeEtapa,
  confirmar,
  readOnly,
  setCloseModal,
}) => {
  const { winWidth } = useWindowDimension();

  var estiloBack = {};

  if (readOnly) {
    estiloBack = {
      backgroundImage: 'none',
      height: 'unset',
      marginBottom: '25px',
    };
  } else if (!readOnly && confirmar) {
    estiloBack = {
      backgroundImage: `url(${bgActive})`,
      height: '100vh',
    };
  } else {
    estiloBack = { backgroundImage: `url(${bgInactive})`, height: '100vh' };
  }

  return (
    <div className='centralized base' style={estiloBack}>
      <div
        className='centralized-column base__inner'
        style={
          readOnly
            ? { height: '420px' }
            : { height: winWidth < 720 ? 'auto' : 'calc(566px - 50px)' }
        }
      >
        {readOnly && (
          <span
            style={{
              position: 'absolute',
              right: '-10px',
              top: '-10px',
              borderRadius: '50%',
            }}
            onClick={() => {
              setCloseModal(false);
            }}
          >
            <Close corBackground={'#ffffff'} />
          </span>
        )}
        <div className='centralized base__inner__header'>
          <TermosDeUso
            style={{ color: '#1D3054', height: '44px', width: '44px' }}
          />
          <div className='centralized-column base__inner__header__title'>
            <span>Termos de uso do site:</span>
            <span>Normas de utilização da plataforma</span>
          </div>
        </div>
        <div className='centralized-space-between base__inner__type'>
          <span>{nomeEtapa}</span>
          <div
            className='centralized-column base__inner__type__stage'
            style={readOnly ? { display: 'none' } : { display: 'block' }}
          >
            <div className='base__inner__type__stage__inner'>
              <span>Etapa {etapa}/2</span>
            </div>
            <div className='centralized base__inner__type__stage__marker'>
              <div
                className='centralized base__inner__type__stage__marker__item'
                style={
                  etapa == '1'
                    ? { backgroundColor: '#1D3054' }
                    : { backgroundColor: '#F5F5F5' }
                }
              ></div>
              <div
                className='centralized base__inner__type__stage__marker__item'
                style={
                  etapa == '2'
                    ? { backgroundColor: '#1D3054' }
                    : { backgroundColor: '#F5F5F5' }
                }
              ></div>
            </div>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Base;
